// react imports
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputNumber, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import axios from "axios";

// common imports
import { API_URL } from "common/constants/config";

import CategoryHeader from "./CategoryHeader";
import "./css/Pagination.css";
import "./css/Table.css";
import { FLIGHT_TYPE_NAMES } from "./constants/aviation";

function Aviation() {
  type FlightType = "national" | "european" | "international";

  interface UpdatePayloadValues {
    co2KgPerKm: number | null;
    averageKmPerFlight: {
      [flightType: string]: number | null;
    };
  }

  interface AviationData {
    key: string;
    flightType: string;
    averageKmPerFlight: number;
    co2KgPerKm: number;
  }

  const [aviation, setAviation] = useState<AviationData[]>([]);
  const { control, handleSubmit, setValue } = useForm();

  const columns: ColumnsType<AviationData> = [
    {
      title: "Tipo de vuelo",
      key: "flightType",
      dataIndex: "flightType",
      align: "center",
      width: 209,
    },
    {
      title: "Km",
      key: "averageKmPerFlight",
      dataIndex: "averageKmPerFlight",
      align: "center",
      width: 219,
      render: (value, record) => (
        <Controller
          name={`averageKmPerFlight.${record.key}`}
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              {...field}
              decimalSeparator=","
              onPressEnter={handlePressEnter}
            />
          )}
        />
      ),
    },
    {
      title: "kg CO2/Km",
      key: "co2KgPerKm",
      dataIndex: "co2KgPerKm",
      align: "center",
      width: 231,
      render: (value) => (
        <Controller
          name="co2KgPerKm"
          control={control}
          defaultValue={value}
          render={({ field }) => (
            <InputNumber
              {...field}
              decimalSeparator=","
              onChange={handleEmissionChange}
              onPressEnter={handlePressEnter}
            />
          )}
        />
      ),
    },
  ];

  function handleEmissionChange(value: number | string | unknown) {
    setValue("co2KgPerKm", value);
  }

  function handlePressEnter(e: React.KeyboardEvent<HTMLInputElement>) {
    e.preventDefault();
  }

  async function onSubmit(values: UpdatePayloadValues) {
    const payload = {
      airTravel: values,
    };

    await axios.put("/admin/calculator/transport", payload, {
      baseURL: API_URL,
    });
  }

  async function fetchAviation() {
    const {
      data: {
        transport: { airTravel },
      },
    } = await axios.get("/admin/calculator/transport", { baseURL: API_URL });

    const mappedAviation = Object.entries(airTravel.averageKmPerFlight).map(
      ([flightType, distance]) => {
        return {
          key: flightType,
          flightType: FLIGHT_TYPE_NAMES[flightType as FlightType],
          averageKmPerFlight: distance as number,
          co2KgPerKm: airTravel.co2KgPerKm as number,
        };
      }
    );
    setAviation(mappedAviation);
  }

  useEffect(() => {
    fetchAviation();
  }, []); // eslint-disable-line

  return (
    <>
      <CategoryHeader title="Aviación" formName="airTravel" />
      <form id="airTravel" onSubmit={handleSubmit(onSubmit)}>
        <Table columns={columns} dataSource={aviation} pagination={false} />
      </form>
    </>
  );
}

export default Aviation;
